export default __webpack_public_path__ + "static/media/038-polar bear.c6d2bada.svg";